import { i18n } from 'i18n'
import { makeAutoObservable } from 'mobx'
import { api } from 'store/api'
import { me } from 'store/me'
import { skipAsync } from 'util/async'
import { validateEmail } from 'util/form'

export class EmailFormStore {
  private _touch = false
  private _email = ''
  private _element: HTMLInputElement | undefined

  constructor() {
    makeAutoObservable(this)
  }

  check(): boolean {
    this.touch = true
    if (!this.error) return true
    this.element?.focus()
    return false
  }

  get touch(): boolean {
    return this._touch
  }

  set touch(value: boolean) {
    this._touch = value
  }

  get email(): string {
    return this._email
  }

  set email(value: string) {
    this._email = value
  }

  get element(): HTMLInputElement | undefined {
    return this._element
  }

  set element(value: HTMLInputElement | undefined) {
    this._element = value
  }

  reset() {
    this._touch = false
    this._email = me.email
  }

  get error(): string | undefined {
    const email = this._email.trim()
    if (!email) return i18n('PleaseEnterEmail')
    if (!validateEmail(email)) return i18n('PleaseEnterCorrectEmail')
    return undefined
  }

  readonly save = skipAsync(async () => {
    if (!this.check()) return
    const email = this._email.trim()
    if (email && email !== me.email) {
      me.email = email
      void api.updateUser({ email })
    }
  })
}
